import React from 'react';
interface IconCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
}
export function IconCard({
  icon,
  title,
  description,
  className = ''
}: IconCardProps) {
  return <div className={`flex flex-col items-center text-center p-6 rounded-2xl bg-[#F8C8DC] bg-opacity-30 border border-[#F8C8DC] shadow-sm transition-transform hover:-translate-y-1 h-full ${className}`} data-id="element-181">
      <div className="w-16 h-16 rounded-full bg-[#FFF8F0] flex items-center justify-center text-[#6B1D4A] mb-4 shadow-sm" data-id="element-182">
        {icon}
      </div>
      <h3 className="font-heading text-xl font-bold text-[#2D1A1A] mb-2" data-id="element-183">
        {title}
      </h3>
      <p className="font-body text-[#2D1A1A] opacity-80" data-id="element-184">{description}</p>
    </div>;
}